'use client';

// import { CmsImageProps } from '@bayada/interfaces';
// import { CmsImage } from '@bayada/shared/ui-components';
// import { motion, useAnimationFrame, useReducedMotion } from 'framer-motion';
// import { useRef } from 'react';
// import styles from './slide-track.module.scss';

// export interface SlideTrackProps {
//   internalName: string;
//   trackImages: CmsImageProps[];
//   scrollSpeed: string;
// }

import { ICmsImage } from '@bayada/interfaces';
import { CmsImage } from '@bayada/shared/ui-components';
import { motion, useAnimationFrame, useReducedMotion } from 'framer-motion';
import { useRef } from 'react';
import styles from './slide-track.module.scss';

export interface SlideTrackProps {
  internalName: string;
  trackImages: ICmsImage[];
  scrollSpeed: string;
}

const speedMap: Record<string, number> = {
  slow: 1,
  medium: 2,
  fast: 3
};

export const SlideTrack = ({
  trackImages,
  scrollSpeed = 'medium'
}: SlideTrackProps) => {
  const shouldReduceMotion = useReducedMotion();
  const containerRef = useRef<HTMLDivElement>(null);
  const isHovering = useRef(false);
  const speed = speedMap[scrollSpeed.toLowerCase()] || speedMap.medium;

  // Animation logic
  useAnimationFrame(() => {
    const container = containerRef.current;
    if (shouldReduceMotion || !container || isHovering.current) return;

    container.scrollLeft += speed;

    // Reset scroll to start for infinite loop
    if (container.scrollLeft >= container.scrollWidth / 2) {
      container.scrollLeft = 0;
    }
  });

  // Duplicate images for seamless looping
  const duplicatedImages = [...trackImages, ...trackImages];

  return (
    <div
      className={styles.trackContainer}
      ref={containerRef}
      onMouseEnter={() => (isHovering.current = true)}
      onMouseLeave={() => (isHovering.current = false)}
    >
      <motion.div
        className={styles.track}
        aria-label="Sliding image track"
        role="region"
      >
        {duplicatedImages.map((img, i) => (
          <div key={i} className={styles.imageWrapper}>
            <CmsImage className={styles.image} {...img} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};
